import { AfterViewInit, Component, ElementRef, forwardRef, Injector, Input, OnInit, ViewChild, Self, Optional } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { dateMaskPipe } from '../mask-pipes';
import { MatFormFieldControl } from '@angular/material';
import { OgCustomInput } from '../OgCustomInput';
import { FocusMonitor } from '@angular/cdk/a11y';
export const datePatternBR = /(\d{2})\/(\d{2})\/(\d{4})/;
export function validateDateFormat(c: FormControl) {
  const err = {
    dateFormat: {
      valid: false
    }
  };
  const dateString = c.value;
  if (!c.value) {
    return null;
  }
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
    return err;
  }

  const parts = dateString.split('/');
  const day = parseInt(parts[1], 10);
  const month = parseInt(parts[0], 10);
  const year = parseInt(parts[2], 10);

  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month === 0 || month > 12) {
    return err;
  }

  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
    monthLength[1] = 29;
  }

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1] ? null : err;
}
export function validateJSNativeDate(c: FormControl) {
  const err = {
    dateFormat: {
      valid: false
    }
  };

  return c.value instanceof Date ? null : err;
}
export const DATE_INPUT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => OgDateInputComponent),
  multi: true
};
export const DATE_INPUT_VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useValue: validateDateFormat,
  multi: true
};
@Component({
  selector: 'og-date-input',
  template: `<ng-container *ngIf="isMaterialFormField; else elseTemplate">
  <input matInput [textMask]="dateMask" [placeholder]="placeholder" [value]="_userInput"
    #dateInput (change)="validateAndSetDate(dateInput)" (keyup)="keyUp(dateInput, $event)">
</ng-container>
<ng-template #elseTemplate>
  <input [textMask]="dateMask" [placeholder]="placeholder" [value]="_userInput" #dateInput
    (change)="validateAndSetDate(dateInput)" (keyup)="propagateTouch(dateInput) && validateAndSetDate(dateInput)">
  <div class="form-error" ogDefaultFormErrors></div>
</ng-template>
`,
  styles: [``],
  providers: [
    // DATE_INPUT_VALUE_ACCESSOR,
    DATE_INPUT_VALIDATOR,
    { provide: MatFormFieldControl, useExisting: OgDateInputComponent }
  ]
})
export class OgDateInputComponent extends OgCustomInput implements
  MatFormFieldControl<String>,
  ControlValueAccessor,
  ControlValueAccessor, OnInit {

  static nextId = 0;
  controlType = 'og-date-input';
  id = `og-date-input-${OgDateInputComponent.nextId++}`;
  autofilled?: boolean;
  dateMask: any;
  @Input() JSDate = false;

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    protected fm: FocusMonitor,
    protected elRef: ElementRef
  ) {
    super(ngControl, fm, elRef);
  }
  _userInput: String = '';
  // @ViewChild('dateInput') dateInput: ElementRef;


  ngOnInit() {
    this.elRef.nativeElement.parentNode.classList.contains('mat-form-field-infix');
    // console.log();
    this.dateMask = {
      mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
      keepCharPositions: true,
      pipe: dateMaskPipe,
    };
    // if (this.value instanceof Date) {
    //   this.userInput = this.value.toLocaleDateString('pt-BR');
    // }
  }

  dateFromString(dateString) {
    if (datePatternBR.test(dateString)) {
      return new Date(dateString.replace(datePatternBR, '$3-$2-$1T00:01:00'));
    }
  }

  // setDate(date) {
  //   // this._userInput = date;
  //   this.writeValue(date);
  // }

  keyUp(input: HTMLInputElement, event: KeyboardEvent) {
    this.propagateTouch(event);
    this.validateAndSetDate(input);
  }

  validateAndSetDate(input: HTMLInputElement) {
    let value: String | Date = input.value;
    if (datePatternBR.test(input.value) && this.JSDate) {
      value = new Date(this.dateFromString(input.value));
    }
    this.writeValue(value);
    this.propagateChanges(value);
    this.checkErrorState();
  }
}
